import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { MTracingItem } from "../../models/tracing-item-model";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SieniService } from "../../services/sieni.service";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";
import { MResponsible } from "../../models/responsible.model";
import { GlobalsService } from "../../services";

@Component({
  selector: "tracing-item",
  templateUrl: "./tracing-item.component.html",
  styleUrls: ["./tracing-item.component.scss"]
})
export class TracingItemComponent implements OnInit {
  constructor(
    private modalService: NgbModal,
    private sieniServie: SieniService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private globalService: GlobalsService
  ) {}

  @Input() public item: MTracingItem = null;
  @Output() public delete = new EventEmitter<number>();
  public currentStatus: string = "";
  public sending: boolean = false;

  ngOnInit() {
    switch (this.item.status.order) {
      case 1:
        this.currentStatus = "register.crumbs.register";
        break;

      case 2:
        this.currentStatus = "validation.crumbs.validation";
        break;

      case 3:
        this.currentStatus = "tracing.sections.analisis";
        break;

      case 4:
        this.currentStatus = "tracing.sections.plan";
        break;

      case 5:
        this.currentStatus = "tracing.sections.verification";
        break;

      case 6:
        this.currentStatus = "tracing.sections.execution";
        break;

      case 7:
        this.currentStatus = "tracing.sections.efficacy";
        break;

      default:
        this.currentStatus = "tracing.sections.approval";
        break;
    }
  }

  public sendToHistory(modal) {
    if (this.item.status.id === 9) {
      this.modalService.open(modal, { centered: true }).result.then(
        () => {
          this.sending = true;
          this.sieniServie.sendToHistoryById(this.item.id).subscribe(
            res => {
              // console.log(res)
              this.sending = false;
              this.delete.emit(this.item.id);
              this.toastr.success(
                this.translate.instant("tracing.alert.success", {
                  name: this.item.title,
                  id: this.item.numero
                })
              );
            },
            () => {
              this.sending = false;
              this.toastr.error(
                this.translate.instant("tracing.alert.error", {
                  name: this.item.title,
                  id: this.item.numero
                })
              );
            }
          );
        },
        () => {}
      );
    } else {
      this.toastr.error(
        this.translate.instant("tracing.alert.notYet", {
          name: this.item.title,
          id: this.item.numero
        })
      );
    }
  }

  // public sendReminder(modal){
  //   if (this.item.status.id >= 3 && this.item.status.id <= 6) {
  //     this.modalService.open(modal, {centered: true}).result.then(()=>{

  //     }, ()=>{})
  //   } else {
  //     this.toastr.error(this.translate.instant('historic.notTreatment'))
  //   }
  // }

  public showStatus(status, reminder) {
    this.modalService.open(status, { centered: true }).result.then(
      () => {
        if (this.item.status.id >= 3 && this.item.status.id <= 6) {
          this.modalService.open(reminder, { centered: true }).result.then(
            () => {
              this.toastr.success(
                this.translate.instant("historic.reminderSuccess")
              );
            },
            () => {}
          );
        } else {
          this.toastr.error(
            this.translate.instant("historic.notTreatment", {
              name: this.item.title,
              id: this.item.numero
            })
          );
        }
      },
      () => {}
    );
  }

  public setResponsibles(modal) {
    /* Validar que solo lo pueda abrir el creador o el aprobador */
    if (
      +this.globalService.user.id === +this.item.approver.id ||
      +this.globalService.user.id === +this.item.creator.id
    ) {
      // console.log(this.item);
      this.modalService.open(modal, { centered: true, size: "lg" }).result.then(
        () => {
          this.toastr.success(
            this.translate.instant("historic.alert.success", {
              name: this.item.title,
              id: this.item.numero
            })
          );
        },
        () => {
          // this.toastr.error(this.translate.instant('historic.alert.error', {
          //   name: this.item.title,
          //   id: this.item.id
          // }))
        }
      );
    }else{
      this.toastr.error(this.translate.instant('tracing.modal.notAuthorized'))
    }
  }

  public resetResponsibles(resps: MResponsible[]) {
    this.item.responsibles = resps;
  }
}
